import moment from 'moment';

import { isObject } from './defaultValues';

export const addDays = (startDate, numOfDays) => {
    if (startDate && !isNaN(numOfDays)) {
        return moment(startDate).add(numOfDays, 'days').format('YYYY-MM-DD');
    }
    return null;
};

export const convertTime = (timeString) => {
    let hours = parseInt(timeString.substring(0, 2));
    const minutes = timeString.substring(3, 5);
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}:${minutes}${ampm}`;
};

/**
 * Inverse of `convertTime()` — parses a formatted display time back into a
 * comparable value.
 *
 * @param {string} timeString Formatted display time as produced by
 *     `convertTime()`, e.g. `"3:30pm"` or `"12:05am"`.
 * @returns {number|null} Minutes elapsed since midnight (0–1439), or `null`
 *     when the value is not a parseable display time.
 */
export const parseDisplayTime = (timeString) => {
    if (typeof timeString !== 'string') {
        return null;
    }
    const match = /^(\d{1,2}):(\d{2})\s*([ap]m)$/i.exec(timeString.trim());
    if (!match) {
        return null;
    }
    const [, rawHours, rawMinutes, meridiem] = match;
    let hours = parseInt(rawHours, 10);
    const minutes = parseInt(rawMinutes, 10);
    if (hours < 1 || hours > 12 || minutes > 59) {
        return null;
    }
    if (meridiem.toLowerCase() === 'pm') {
        hours = hours === 12 ? 12 : hours + 12;
    } else {
        hours = hours === 12 ? 0 : hours;
    }
    return hours * 60 + minutes;
};

export const normalizeTimeSlots = (data, startDate, endDate) => {
    if (!startDate) return;
    let numberOfDays = 4;
    if (endDate) {
        const dateS = moment(startDate);
        const dateE = moment(endDate);
        numberOfDays = dateE.diff(dateS, 'days');
    }

    const allDates = [];
    for (let i = 0; i <= numberOfDays; i++) {
        allDates.push(addDays(startDate, i));
    }

    const result = allDates.map((date) => {
        let times = [];
        const d = moment(date).format('ddd,MMM DD').split(',');
        if (isObject(data) && data[date] && Array.isArray(data[date])) {
            times = data[date].map((item) => convertTime(item.time));
        }

        return {
            date: date,
            weekday: d[0],
            monthDay: d[1],
            times: times,
        };
    });

    return result;
};
